import React from "react";

import { StatsSummary as StatsSummaryComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface StatsSummaryProps {
    subDimensionsData?: any;
    isInsideModal?: boolean;
    componentDescription?: string;
    onButtonClick?: () => void;
}

const StatsSummary: React.FC<StatsSummaryProps> = ({ subDimensionsData, isInsideModal }) => {
    const {
        combinedCustomTopStatsData,
        isFetchingCombinedCustomTopStats,
        isErrorCombinedCustomTopStats,
    } = useSessionDetailsContext();

    const areAllValuesEmpty = combinedCustomTopStatsData?.every((value: any) => {
        return value.length === 0;
    });

    const hasEmptyState =
        !combinedCustomTopStatsData ||
        combinedCustomTopStatsData?.length === 0 ||
        areAllValuesEmpty;

    const isSubDimensionsDataEmpty =
        !subDimensionsData ||
        subDimensionsData?.length === 0 ||
        subDimensionsData?.value?.length === 0;

    if (isFetchingCombinedCustomTopStats) {
        return <ContentLoader height="10.125rem" />;
    }

    const isEmptyState = isInsideModal ? isSubDimensionsDataEmpty : hasEmptyState;

    const data = isInsideModal ? subDimensionsData : combinedCustomTopStatsData;

    if (isEmptyState) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:stats-summary:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                />
            </ComponentWrapper>
        );
    }

    if (!subDimensionsData && isErrorCombinedCustomTopStats && !isFetchingCombinedCustomTopStats) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                />
            </ComponentWrapper>
        );
    }

    return <StatsSummaryComponent data={data} />;
};

export default StatsSummary;
